import {
    apiRequest,
    listPPI,
    listPromotion,
    listGradePromotion,
    listPerjadin,
    listPresensi,
} from "../../../../../services/adapters/kepegawaian/verificationService"

class DataTableRepository {

    fetchRowTableListPPI = async (query, cancelToken) => {
        return await apiRequest("get", listPPI, {
            cancelToken: cancelToken,
            params: query
        }, true)
    }
    fetchRowTableListPromotion = async (query, cancelToken) => {
        return await apiRequest("get", listPromotion, {
            cancelToken: cancelToken,
            params: query
        }, true)
    }
    fetchRowTableListGradePromotion = async (query, cancelToken) => {
        return await apiRequest("get", listGradePromotion, {
            cancelToken: cancelToken,
            params: query
        }, true)
    }
    fetchRowTableListPerjadin = async (query, cancelToken) => {
        return await apiRequest("get", listPerjadin, {
            cancelToken: cancelToken,
            params: query
        }, true)
    }
    fetchRowTableListPresensi = async (query, cancelToken) => {
        return await apiRequest("get", listPresensi, {
            cancelToken: cancelToken,
            params: query
        }, true)
    }
    
}

export default DataTableRepository